/* FUNCTIONS – product page interactions
 * - Variant card selection
 * - Cart fetch + count update
 * Accordions use native <details> – no JS needed.
 */
(function () {
  function initVariantPicker(root) {
    const wraps = root.querySelectorAll('[data-variant-wrap]');
    const cards = root.querySelectorAll('[data-variant-card]');
    const hiddenInput = root.querySelector('input[name="id"]');
    const qtyInput = root.querySelector('input[name="quantity"]');
    const cta = root.querySelector('[data-add-to-cart]');
    const ctaPrice = root.querySelector('[data-cta-price]');

    function select(wrap) {
      const card = wrap.querySelector('[data-variant-card]');
      wraps.forEach((w) => {
        w.classList.remove('is-active');
        const c = w.querySelector('[data-variant-card]');
        if (c) c.setAttribute('aria-checked', 'false');
      });
      wrap.classList.add('is-active');
      if (card) card.setAttribute('aria-checked', 'true');
      const id = wrap.dataset.variantId;
      const qty = wrap.dataset.variantQty || '1';
      const price = wrap.dataset.variantPrice;
      if (hiddenInput) hiddenInput.value = id;
      if (qtyInput) qtyInput.value = qty;
      if (cta) {
        cta.dataset.variantId = id;
        cta.dataset.variantQty = qty;
      }
      if (ctaPrice && price) ctaPrice.textContent = price;
      const perUnit = root.querySelector('[data-per-unit]');
      if (perUnit) perUnit.textContent = wrap.dataset.variantPerUnit || '';
    }

    wraps.forEach((wrap) => {
      wrap.addEventListener('click', () => select(wrap));
      wrap.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          select(wrap);
        }
      });
    });

    const initial = wraps[0];
    if (initial) select(initial);
  }

  async function addToCart(form) {
    const formData = new FormData(form);
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) {
        // Surface Shopify's own (localized) reason, e.g. "… ist bereits ausverkauft".
        let reason = '';
        try {
          const data = await res.json();
          reason = data.description || data.message || '';
        } catch (parseErr) {}
        alert(reason || 'Der Artikel konnte nicht in den Warenkorb gelegt werden. Bitte versuche es erneut.');
        return;
      }
      const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await cartRes.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
      });
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      // Open cart drawer if Horizon's cart drawer exists, else go to /cart
      const drawerTrigger = document.querySelector('[data-cart-drawer-trigger]');
      if (drawerTrigger) {
        drawerTrigger.click();
      } else {
        window.location.href = '/cart';
      }
    } catch (e) {
      console.error(e);
      alert('Der Artikel konnte nicht in den Warenkorb gelegt werden. Bitte versuche es erneut.');
    }
  }

  function initForm(form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      addToCart(form);
    });
  }

  function initGallery(root) {
    const mainImg = root.querySelector('[data-gallery-main]');
    if (!mainImg) return;
    const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    const prevBtn = root.querySelector('[data-gallery-prev]');
    const nextBtn = root.querySelector('[data-gallery-next]');
    let current = 0;

    function goTo(index) {
      current = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[current];
      const src = thumb.dataset.src;
      const alt = thumb.dataset.alt || '';
      if (src) { mainImg.src = src; mainImg.alt = alt; }
      thumbs.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if (prevBtn) prevBtn.hidden = thumbs.length <= 1;
      if (nextBtn) nextBtn.hidden = thumbs.length <= 1;
    }

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => goTo(i));
    });

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

    // Mobile: swipe left/right on the main image to change slides
    const swipeArea = mainImg.closest('.fn-hero__gallery') || mainImg;
    let touchStartX = 0, touchStartY = 0, touching = false;
    swipeArea.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) { touching = false; return; }
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touching = true;
    }, { passive: true });
    swipeArea.addEventListener('touchend', (e) => {
      if (!touching || thumbs.length <= 1) return;
      touching = false;
      const t = e.changedTouches[0];
      const dx = t.clientX - touchStartX;
      const dy = t.clientY - touchStartY;
      // Only act on a clear, mostly-horizontal swipe (don't hijack vertical scroll)
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        goTo(dx < 0 ? current + 1 : current - 1);
      }
    }, { passive: true });

    if (thumbs.length <= 1) {
      if (prevBtn) prevBtn.hidden = true;
      if (nextBtn) nextBtn.hidden = true;
    }
  }

  function initStickyMediaCenter(root) {
    const media = root.querySelector('.fn-hero__media');
    if (!media) return;

    const VISUAL_GAP = 24; // px gap between nav bottom and content (matches Figma)

    // Cache the natural header offset (sticky elements above hero)
    let cachedOffset = null;

    function getHeaderOffset() {
      if (cachedOffset !== null) return cachedOffset;
      cachedOffset = Math.round(root.getBoundingClientRect().top + window.scrollY);
      return cachedOffset;
    }

    function update() {
      cachedOffset = null;
      const headerH = getHeaderOffset();
      const vh = window.innerHeight;
      const mediaH = media.scrollHeight;

      // The media's natural top while still in flow (header + visual gap).
      const mediaStartY = headerH + VISUAL_GAP;

      // Lock only once the BOTTOM of the media (image + thumbnails) reaches the
      // bottom of the viewport — i.e. the thumbnails have scrolled into view
      // (top = vh - mediaH). Cap at the natural start so sticking engages on
      // scroll-down rather than firing immediately. When the media is taller than
      // the viewport this value is negative, so the media scrolls the full
      // distance needed to reveal the thumbnails before locking (the top tucks
      // under the nav, which is unavoidable when the media can't fully fit).
      const stickyTop = Math.min(mediaStartY, vh - mediaH);

      root.style.paddingTop = VISUAL_GAP + 'px';
      media.style.marginTop = '';
      media.style.setProperty('--media-sticky-top', stickyTop + 'px');
    }

    update();
    window.addEventListener('resize', update, { passive: true });
  }

  document.querySelectorAll('[data-functions-product]').forEach((root) => {
    initVariantPicker(root);
    initGallery(root);
    initStickyMediaCenter(root);
    const form = root.querySelector('form[data-add-to-cart-form]');
    if (form) initForm(form);
  });
})();
